import { useEffect } from 'react'

export const useLockScrollOnElementRole = (targetId: string, role: 'menu' | 'dialog' | string = 'menu') => {
  useEffect(() => {
    const scrollContainer = document.getElementById(targetId)
    if (!scrollContainer) return

    const observer = new MutationObserver(() => {
      const active = document.querySelector(`[role="${role}"]`)
      scrollContainer.style.overflow = active ? 'hidden' : 'auto'
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })

    return () => {
      scrollContainer.style.overflow = 'auto'
      observer.disconnect()
    }
  }, [targetId, role])
}
